import * as yup from 'yup';

import { TGetStateResponseCompanyDE } from '../../../../../lapiOverrideTypesDE';

// Copied from CompanyDetailsDE.schema.ts (manual path) — keep in sync if the desktop rule changes.
const postcodeRegexDE = /^[0-9]{2}[0-9]{3}$/;

export const companyManualEntrySchema = yup.object().shape({
  companyName: yup.string().trim().required('benötigt'),
  street: yup.string().trim().required('benötigt'),
  buildingNumber: yup.string().trim().required('benötigt'),
  postcode: yup
    .string()
    .required('benötigt')
    .matches(postcodeRegexDE, 'ungültige Eingabe'),
  town: yup.string().trim().required('benötigt'),
  legalForm: yup
    .string<NonNullable<TGetStateResponseCompanyDE['type']>>()
    .required('benötigt'),
});
